// Generated from src/lib/cartBestBeforePolicy.ts. Run scripts/buildCartBestBeforeWeb2691.cjs.
"use strict";
var agoCartBestBeforePolicy = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // src/lib/cartBestBeforePolicy.ts
  var cartBestBeforePolicy_exports = {};
  __export(cartBestBeforePolicy_exports, {
    cartMixedReviewMessage: () => cartMixedReviewMessage,
    checkCartBestBefore: () => checkCartBestBefore,
    checkCartReview: () => checkCartReview,
    currentCartReviewRemovalIds: () => currentCartReviewRemovalIds,
    currentRemovalIds: () => currentRemovalIds,
    currentStockRemovalIds: () => currentStockRemovalIds,
    deliveryDateKey: () => deliveryDateKey,
    hasCurrentClearanceTag: () => hasCurrentClearanceTag,
    validDateKey: () => validDateKey
  });
  function validDateKey(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = /* @__PURE__ */ new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
  }
  function deliveryDateKey(value) {
    if (validDateKey(value)) return value;
    const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
    const key = match ? `${match[3]}-${match[2]}-${match[1]}` : "";
    return validDateKey(key) ? key : "";
  }
  function hasCurrentClearanceTag(tags) {
    return Array.isArray(tags) ? tags.some((tag) => tag.trim().toLowerCase() === "clearance") : null;
  }
  function record(value) {
    try {
      const parsed = typeof value === "string" ? JSON.parse(value) : value;
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }
  function sydneyDate(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value) || !validDateKey(value.slice(0, 10))) return null;
    const timestamp = Date.parse(value);
    if (!Number.isFinite(timestamp)) return null;
    const parts = new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Sydney",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date(timestamp));
    const part = (key) => parts.find((item) => item.type === key)?.value ?? "";
    const date = `${part("year")}-${part("month")}-${part("day")}`;
    return validDateKey(date) ? date : null;
  }
  function checkCartBestBefore(facts, delivery) {
    const deliveryDate = deliveryDateKey(delivery);
    const unavailable = { status: "unavailable", deliveryDate, issues: [] };
    if (!facts.cartId || !facts.complete || !deliveryDate || !Array.isArray(facts.lines)) return unavailable;
    const ids = /* @__PURE__ */ new Set();
    let quantity = 0;
    for (const line of facts.lines) {
      if (!line.id || ids.has(line.id) || !Number.isSafeInteger(line.quantity) || line.quantity < 1) return unavailable;
      ids.add(line.id);
      quantity += line.quantity;
    }
    if (quantity !== facts.totalQuantity) return unavailable;
    const issues = [];
    for (const line of facts.lines) {
      if (line.clearance === false) continue;
      if (line.clearance !== true) return unavailable;
      const projection = record(line.lifecycle);
      const matched = projection?.schemaVersion === "ago.clearance.lifecycle.v1" && projection.contractRevision === 2 && projection.state === "ACTIVE" && line.variantId && projection.variantId === line.variantId;
      const expiry = matched ? sydneyDate(projection.customerExpiryAt) : null;
      if (!matched || !expiry || !["BEST_BEFORE", "USE_BY"].includes(String(projection?.dateMarkType))) {
        issues.push({ line, reason: "unconfirmed", bestBefore: null });
      } else if (projection?.dateMarkType === "BEST_BEFORE" && deliveryDate >= expiry) {
        issues.push({ line, reason: "delivery_date", bestBefore: expiry });
      }
    }
    return { status: issues.length ? "conflict" : "pass", deliveryDate, issues };
  }
  function currentRemovalIds(approvedFacts, approved, currentFacts, delivery) {
    if (approvedFacts.cartId !== currentFacts.cartId || approved.deliveryDate !== deliveryDateKey(delivery)) return [];
    const current = checkCartBestBefore(currentFacts, delivery);
    if (current.status !== "conflict") return [];
    return current.issues.filter((issue) => approved.issues.some((previous) => previous.line.id === issue.line.id && previous.line.variantId === issue.line.variantId && previous.line.quantity === issue.line.quantity)).map((issue) => issue.line.id);
  }
  function checkCartReview(facts, delivery) {
    if (!facts.complete || facts.lines.some((line) => typeof line.availableForSale !== "boolean")) {
      return { status: "unavailable", issues: [], stockIssues: [], dateCheck: null };
    }
    const stockIssues = facts.lines.filter((line) => !line.availableForSale);
    const dateCheck = deliveryDateKey(delivery) ? checkCartBestBefore(facts, delivery) : null;
    const dateIssues = dateCheck?.status === "conflict" ? dateCheck.issues : [];
    const issues = [...new Map([
      ...stockIssues.map((line) => [line.id, { line, reason: "stock" }]),
      ...dateIssues.map((issue) => [issue.line.id, issue])
    ]).values()];
    if (stockIssues.length) return { status: dateIssues.length ? "mixed" : "stock", issues, stockIssues, dateCheck };
    return dateCheck ? { status: dateCheck.status, issues, stockIssues, dateCheck } : null;
  }
  var cartMixedReviewMessage = (check) => check?.issues.some((issue) => issue.reason === "unconfirmed") ? "Some items are out of stock or have clearance date issues." : "Some items are out of stock or expire by delivery.";
  function currentStockRemovalIds(approved, current) {
    if (current.some((line) => typeof line.availableForSale !== "boolean")) return [];
    const previous = new Map(approved.map((line) => [line.id, line]));
    return current.filter((line) => line.availableForSale === false && previous.get(line.id)?.variantId === line.variantId && previous.get(line.id)?.quantity === line.quantity).map((line) => line.id);
  }
  function currentCartReviewRemovalIds(approvedFacts, approvedStock, approvedDates, current, delivery) {
    if (approvedFacts.cartId !== current.cartId || !current.complete || current.lines.some((line) => typeof line.availableForSale !== "boolean")) return [];
    if (approvedDates && (approvedDates.deliveryDate !== deliveryDateKey(delivery) || checkCartBestBefore(current, delivery).status === "unavailable")) return [];
    return [.../* @__PURE__ */ new Set([
      ...currentStockRemovalIds(approvedStock, current.lines),
      ...approvedDates ? currentRemovalIds(approvedFacts, approvedDates, current, delivery) : []
    ])];
  }
  return __toCommonJS(cartBestBeforePolicy_exports);
})();
